module.exports = {
	"id": "LC",
	"name": "Saint Lucia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.090832,
			"12": null,
			"13": null,
			"14": null,
			"15": 0.006488,
			"16": null,
			"17": null,
			"18": 0.025952,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.051904,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.006488,
			"27": 0.058392,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.019464,
			"32": 0.168688,
			"33": null,
			"34": 0.012976,
			"35": 0.012976,
			"36": 0.025952,
			"37": 0.051904,
			"38": 0.012976,
			"39": 0.038928,
			"40": 0.012976,
			"41": 0.019464,
			"42": 0.019464,
			"43": 0.181664,
			"44": 0.058392,
			"45": 0.038928,
			"46": 0.051904,
			"47": 0.03244,
			"48": 0.077856,
			"49": 0.934272,
			"50": 0.168688,
			"51": 1.03808,
			"52": 0.408744,
			"53": 28.696424,
			"54": 7.577984,
			"55": 0.233568,
			"56": 0.06488,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.051904,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.012976,
			"37": 0.019464,
			"38": 0.06488,
			"39": 0.019464,
			"40": 0.025952,
			"41": 0.012976,
			"42": 0.025952,
			"43": 0.084344,
			"44": 0.03244,
			"45": 0.155712,
			"46": 0.071368,
			"47": 0.434696,
			"48": 0.538504,
			"49": 4.048512,
			"50": 0.168688,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.045416
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.038928,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.012976,
			"34": null,
			"35": null,
			"36": 0.071368,
			"37": 0.369816,
			"38": 0.09732,
			"39": 0.012976,
			"40": 0.68124,
			"41": 0.090832,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.03244
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.012976,
			"6": null,
			"7": 0.06488,
			"8": 0.071368,
			"9": 0.045416,
			"10": 0.882368,
			"3.1": null,
			"3.2": null,
			"5.1": 0.03244,
			"6.1": 0.03244,
			"7.1": 0.025952,
			"9.1": 0.538504
		},
		"ios_saf": {
			"8": 0,
			"10": 2.25674511241,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0608166694421,
			"8.1-8.4": 0.112356219817,
			"9.0-9.2": 0.0536011323897,
			"9.3": 0.817760865945
		},
		"android": {
			"3": 0,
			"4": 0.107864682171,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0134830852713,
			"4.1": 0.389083317829,
			"4.2-4.3": 0.972708294574,
			"4.4": 2.23048753488,
			"4.4.3-4.4.4": 2.24974908527
		},
		"ie": {
			"6": null,
			"7": 0.006488,
			"8": 0.12976,
			"9": 0.240056,
			"10": 0.155712,
			"11": 3.581376,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0644243514763,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00178956531879
		},
		"edge": {
			"12": 0.467136,
			"13": 1.39492,
			"14": 2.770376
		},
		"ie_mob": {
			"10": 0.17520428169,
			"11": 0.71333171831
		},
		"bb": {
			"7": 0.12292,
			"10": null
		},
		"samsung": {
			"0": 3.220504
		},
		"and_uc": {
			"0": 1.155448
		},
		"op_mini": {
			"0": 0.867978083205
		},
		"and_chr": {
			"0": 24.801136
		},
		"and_ff": {
			"0": 0.038632
		}
	},
	"total": 98.298984
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/LC.json
 ** module id = 573
 ** module chunks = 0
 **/